import { api } from '@packages/backend/convex/_generated/api';
import { getUserErrorMessage } from '@packages/shared';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { FunctionReturnType } from 'convex/server';
import { useQuery } from 'convex-helpers/react';
import { ErrorAlert } from '@/components/ui+/ErrorAlert';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export type SiteData = NonNullable<FunctionReturnType<typeof api.app.getDataByUrlX>>;

export const Route = createFileRoute('/$companyLocationCode/$siteCode')({
  component: SiteCheckInCachedQueries,
});

function SiteCheckInCachedQueries() {
  const { companyLocationCode, siteCode } = Route.useParams();

  const {
    data: siteWrap,
    isPending,
    isError,
    error,
  } = useQuery(api.app.getDataByUrlX, {
    companyLocationCode,
    siteCode,
  });

  if (isPending) {
    return (
      <div className="flex flex-1 items-center justify-center p-4">
        <LoadingIcon />
      </div>
    );
  }

  if (isError) {
    return <ErrorAlert message={getUserErrorMessage(error)} />;
  }

  if (!siteWrap) {
    return <ErrorAlert message="This site could not be found." />;
  }

  return <Outlet />;
}
